import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { formatApiError } from '../../context/AuthContext';

const API = (process.env.CRA_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL);

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [pwd, setPwd] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (pwd.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (pwd !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, new_password: pwd });
      navigate('/academy/login?reset=1', { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#0b0b0e]">
      <div className="w-full max-w-[440px] bg-white rounded-2xl p-8 shadow-2xl">
        <h1 className="text-[22px] font-extrabold text-[#1D1D1F] mb-2">Set a new password</h1>
        {!token && <div className="text-red-600 text-[13px] mb-3">Missing reset token.</div>}
        <form onSubmit={onSubmit} className="space-y-4">
          <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)}
            data-testid="reset-pwd" placeholder="New password (min 8 chars)"
            className="w-full px-4 py-2.5 rounded-lg border border-[#E5E5E7] focus:border-[#c9a227] outline-none" />
          <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
            data-testid="reset-confirm" placeholder="Confirm password"
            className="w-full px-4 py-2.5 rounded-lg border border-[#E5E5E7] focus:border-[#c9a227] outline-none" />
          {error && <div className="text-red-600 text-[13px]">{error}</div>}
          <button type="submit" disabled={loading || !token} data-testid="reset-submit"
            className="w-full px-6 py-3 rounded-full text-[14px] font-bold uppercase tracking-[0.16em] text-[#0e0e10] disabled:opacity-60"
            style={{ background: 'linear-gradient(90deg,#e6c35a,#c9a227,#a8871a)' }}>
            {loading ? 'Saving…' : 'Save new password'}
          </button>
        </form>
        <div className="mt-6 text-[13px]">
          <Link to="/academy/login" className="text-[#c9a227] hover:underline font-semibold">← Back to login</Link>
        </div>
      </div>
    </div>
  );
}
